import * as React from 'react';

import { translate } from '~l10n/client';

import Anchor from '../../../../shared/components/elements/Anchor';
import { buildAddressString } from '../../../../shared/components/src/SchoolSearch/buildAddressString';
import { SchoolSearch } from '../../../../shared/components/src/SchoolSearch/SchoolSearch';
import { createSchool } from '../../../src/api/schoolSearch/schoolSearch';
import { CreateSchoolModal } from './CreateSchoolModal';

interface Props {
  legacyModel: any;
  legacyController: any;
}

export function SchoolSelector(props: Props) {
  const { legacyModel, legacyController } = props;

  const [isEditMode, setIsEditMode] = React.useState(false);
  const [showCreateModal, setShowCreateModal] = React.useState(false);

  return (
    <div className={' flex flex-col'}>
      {isEditMode ? (
        <>
          <SchoolSearch
            legacyModel={legacyModel}
            onSchoolSelected={() => {
              setIsEditMode(false);
            }}
            onCreateSchoolClicked={() => setShowCreateModal(true)}
          />
          <Anchor
            label={translate('Cancel')}
            onClick={() => {
              legacyModel.restoreInitialValues();
              setIsEditMode(false);
            }}
          />
        </>
      ) : (
        <>
          <span>{legacyModel.schoolName}</span>
          <span>{legacyModel.description}</span>
          <Anchor
            label={translate('Change School')}
            onClick={() => setIsEditMode(!isEditMode)}
          />
        </>
      )}

      {showCreateModal && (
        <CreateSchoolModal
          legacyModel={legacyModel}
          legacyController={legacyController}
          onCancel={() => {
            legacyModel.restoreInitialValues();
            setIsEditMode(false);
            setShowCreateModal(false);
          }}
          open={showCreateModal}
          onConfirm={() => {
            if (legacyModel.validateDemographics(true)) {
              legacyModel.blingId = null;
              legacyModel.description = buildAddressString({
                city: legacyModel.city,
                state: legacyModel.state,
                country: legacyModel.country,
                postal_code: legacyModel.zipCode,
              });
              setShowCreateModal(false);
              setIsEditMode(false);
              createSchool({
                city: legacyModel.city,
                state: legacyModel.state,
                country: legacyModel.country,
                zip_code: legacyModel.zipCode,
                school_name: legacyModel.schoolName,
                description: legacyModel.description,
                onError: (err) => {
                  console.error(err);
                },
                onSuccess: (data) => {
                  console.log(data);
                },
              });
            }
          }}
        />
      )}
    </div>
  );
}
